/* eslint-disable camelcase */
import { useFormik } from 'formik';
import React, { useContext, useState } from 'react';
import { WishlistContext } from '..';
import Form from '../../form-elements/Form';
import Legend from '../../form-elements/Legend';
import Required from '../../form-elements/Required';
import TextField from '../../form-elements/TextField';
import LoadingSpinner from '../../LoadingSpinner';

const ShareWithAFriend = () => {
  const {
    wishlist,
    setShowShareWithAFriend: setShow,
    shareWithAFriendInitial,
    shareWithAFriendValidationSchema,
    handleReCaptchaVerify,
    postForm,
    form,
    disable,
  } = useContext(WishlistContext);

  const [waiting, setWaiting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const portalContainer = document.createElement('div');
  portalContainer.classList = 'c-dialog c-dialog--wishlist-share';
  portalContainer.role = 'dialog';

  const {
    handleBlur,
    touched,
    values,
    errors,
    setFieldValue,
    resetForm,
    submitForm,
  } = useFormik({
    initialValues: shareWithAFriendInitial,
    validationSchema: shareWithAFriendValidationSchema,
    onSubmit: async () => {
      const formAction = 'wishlist_friend';
      const recaptchaToken = await handleReCaptchaVerify(formAction);

      const formData = {
        ...values,
        'g-recaptcha-response': recaptchaToken,
      };

      await postForm(formData, recaptchaToken, () => {
        setSubmitted(true);
        resetForm();
        setWaiting(false);

        // post to data layer - matching share with us as only one dataLayer set up
        // in backend WishlistFormSubmission.php - could be this doesn't get collected also?
        const { first_name, last_name, email, wishlist, opt_in } = values;

        // set email for DotDigital WBT
        window.dmPt('identify', email);

        const dataObj = {
          event: '2024_form_submit',
          data: {
            eventLabel: 'Submit Wishlist - Friend',
            formType: 'wishlist',
            marketingConsent: opt_in,
            firstName: first_name,
            lastName: last_name,
            email,
            wishlist,
          },
        };

        window.dataLayer.push(dataObj);
      });
    },
  });

  const {
    first_name,
    last_name,
    email,
    friend_first_name,
    friend_last_name,
    friend_email,
    opt_in,
    honeypot,
    client_id,
    current_page,
    referrer,
  } = values;

  const { intro, form: formFields, thank_you } = form.formFriend;

  const {
    first_name: firstNameMeta,
    last_name: lastNameMeta,
    email: emailMeta,
    friend_first_name: friendFirstNameMeta,
    friend_last_name: firendLastNameMeta,
    friend_email: friendEmailMeta,
    submit: submitMeta,
    opt_in: optInMeta,
    gdpr: gdprMeta,
  } = formFields;

  return (
    <>
      <div
        className="c-dialog__overlay"
        tabIndex="-1"
        data-a11y-dialog-hide
      ></div>

      <div
        className="c-dialog__container"
        role="dialog"
        aria-labelledby="dialog-title"
      >
        <button
          data-a11y-dialog-hide=""
          className="c-dialog__close"
          onClick={() => setShow(false)}
        >
          Close
        </button>

        <div className="c-dialog__content">
          <Form
            className="c-wishlist__share"
            onSubmit={async (e) => {
              e.preventDefault();
              setWaiting(true);
              submitForm();
            }}
          >
            {!waiting && !submitted ? (
              <>
                <div className="c-wishlist__share__intro">
                  <h2>{intro.title}</h2>

                  <p class="o-text">{intro.content}</p>

                  <p>*Required fields</p>
                </div>

                <section className="c-wishlist__share__section">
                  <h3>Your Details</h3>

                  <Legend>Your details</Legend>

                  <fieldset className="c-wishlist__share__fieldset">
                    <div className="c-form__item">
                      <label className="u-a11y">
                        Honeypot
                        <input
                          name="honeypot"
                          type="hidden"
                          onChange={() => setFieldValue('honeypot', true)}
                          value={honeypot}
                        />
                      </label>

                      <input name="referrer" value={referrer} type="hidden" />
                      <input name="client_id" value={client_id} type="hidden" />
                      <input
                        name="current_page"
                        value={current_page}
                        type="hidden"
                      />

                      <TextField
                        label={
                          <>
                            First Name
                            <Required />
                          </>
                        }
                        name={firstNameMeta.id}
                        id={firstNameMeta.id}
                        placeholder={firstNameMeta.placeholder}
                        onBlur={handleBlur}
                        handleChange={(value) =>
                          setFieldValue('first_name', value)
                        }
                        value={first_name}
                        validationError={
                          errors.first_name && touched[firstNameMeta.id]
                        }
                        validationMessage={errors.first_name}
                      />
                    </div>

                    <div className="c-form__item">
                      <TextField
                        label={
                          <>
                            Last Name
                            <Required />
                          </>
                        }
                        name={lastNameMeta.id}
                        id={lastNameMeta.id}
                        placeholder={lastNameMeta.placeholder}
                        onBlur={handleBlur}
                        handleChange={(value) =>
                          setFieldValue('last_name', value)
                        }
                        value={last_name}
                        validationError={
                          errors.last_name && touched[lastNameMeta.id]
                        }
                        validationMessage={errors.last_name}
                      />
                    </div>

                    <div className="c-form__item">
                      <TextField
                        label={
                          <>
                            Email
                            <Required />
                          </>
                        }
                        name={emailMeta.id}
                        id={emailMeta.id}
                        placeholder={emailMeta.placeholder}
                        onBlur={handleBlur}
                        handleChange={(value) => setFieldValue('email', value)}
                        value={email}
                        validationError={errors.email && touched[emailMeta.id]}
                        validationMessage={errors.email}
                      />
                    </div>
                  </fieldset>
                </section>

                <section className="c-wishlist__share__section">
                  <h3>Your Friends Details</h3>

                  <Legend>Your Friends details</Legend>

                  <fieldset className="c-wishlist__share__fieldset">
                    <div className="c-form__item">
                      <TextField
                        label={
                          <>
                            Friend First Name
                            <Required />
                          </>
                        }
                        name={friendFirstNameMeta.id}
                        id={friendFirstNameMeta.id}
                        placeholder={friendFirstNameMeta.placeholder}
                        onBlur={handleBlur}
                        handleChange={(value) =>
                          setFieldValue('friend_first_name', value)
                        }
                        value={friend_first_name}
                        validationError={
                          errors.friend_first_name &&
                          touched[friendFirstNameMeta.id]
                        }
                        validationMessage={errors.friend_first_name}
                      />
                    </div>

                    <div className="c-form__item">
                      <TextField
                        label={
                          <>
                            Friend Last Name
                            <Required />
                          </>
                        }
                        name={firendLastNameMeta.id}
                        id={firendLastNameMeta.id}
                        placeholder={firendLastNameMeta.placeholder}
                        onBlur={handleBlur}
                        handleChange={(value) =>
                          setFieldValue('friend_last_name', value)
                        }
                        value={friend_last_name}
                        validationError={
                          errors.friend_last_name &&
                          touched[firendLastNameMeta.id]
                        }
                        validationMessage={errors.friend_last_name}
                      />
                    </div>

                    <div className="c-form__item">
                      <TextField
                        label={
                          <>
                            Friend Email
                            <Required />
                          </>
                        }
                        name={friendEmailMeta.id}
                        id={friendEmailMeta.id}
                        placeholder={friendEmailMeta.placeholder}
                        onBlur={handleBlur}
                        handleChange={(value) =>
                          setFieldValue('friend_email', value)
                        }
                        value={friend_email}
                        validationError={
                          errors.friend_email && touched[friendEmailMeta.id]
                        }
                        validationMessage={errors.friend_email}
                      />
                    </div>
                  </fieldset>
                </section>

                <section className="c-wishlist__share__section">
                  <Legend>Opt in</Legend>

                  <fieldset className="c-wishlist__share__fieldset c-wishlist__share__fieldset--opt-in">
                    <label htmlFor={optInMeta.id} className="c-form__checkbox">
                      <input
                        id={optInMeta.id}
                        value={optInMeta.id}
                        type="checkbox"
                        name={optInMeta.id}
                        onChange={() => setFieldValue('opt_in', !opt_in)}
                        checked={opt_in}
                      />
                      <span></span>
                    </label>

                    <div className="u-mb-4">
                      <p
                        className="u-weight--semibold u-mb-0"
                        dangerouslySetInnerHTML={{
                          __html: optInMeta.options[0].display,
                        }}
                      ></p>

                      <div
                        className="u-mb-0"
                        dangerouslySetInnerHTML={{
                          __html: optInMeta.options[0].info,
                        }}
                      ></div>
                    </div>
                  </fieldset>
                </section>

                <div className="c-form__item c-form__item--gdpr-no-checkbox u-mb-3">
                  <div>
                    <p className="u-weight--semibold u-mb-0">
                      {gdprMeta.display}
                    </p>

                    <p
                      className="c-form__small"
                      dangerouslySetInnerHTML={{
                        __html: gdprMeta.info,
                      }}
                    ></p>
                  </div>
                </div>

                <div className="c-wishlist__share__submit">
                  <button
                    className="o-btn o-btn--purple"
                    type="submit"
                    disabled={disable(errors, values, shareWithAFriendInitial)}
                  >
                    {submitMeta.label}
                  </button>
                </div>
              </>
            ) : null}

            {waiting && <LoadingSpinner />}

            {submitted && !waiting && (
              <div
                dangerouslySetInnerHTML={{ __html: thank_you.message }}
              ></div>
            )}
          </Form>
        </div>
      </div>
    </>
  );
};

export default ShareWithAFriend;
